import { notification } from 'antd'
import { Dispatch, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getListSentEmailResults } from 'src/app/shared/services/BackgroundService'

export interface IResultScreenHook {
  resultList: any
  isGettingList: boolean
  setResultList: Dispatch<any>
  getResultList: (payload: Partial<any>, isDownload?: boolean, emailLogData?: any) => Promise<void>
}

export const useResultScreen = (): IResultScreenHook => {
  const [resultList, setResultList] = useState<any>({
    data: [],
    total: 0,
    pageIndex: 0,
    pageSize: 10,
  })
  const [api] = notification.useNotification()
  const { t } = useTranslation()

  const [isGettingList, setIsSettingList] = useState<boolean>(false)

  const getResultList = useCallback(
    async (payload: any, isDownload = false, emailLogData: any) => {
      try {
        setIsSettingList(true)
        if (emailLogData) {
          const res = await getListSentEmailResults({
            ...payload,
            ...emailLogData,
          })
          if (res?.data && !isDownload) {
            setResultList(res?.data)
          }
          console.log('RES DATA: ', res?.data)
          return res?.data
        }
        return {
          items: [],
          total: 0,
        }
      } catch (error: any) {
        api.error({
          message: t('common:error'),
          description: `${error?.error}`,
          placement: 'topRight',
        })
      } finally {
        setIsSettingList(false)
      }
    },
    [api, t],
  )

  return {
    resultList,
    isGettingList,
    setResultList,
    getResultList,
  }
}
